import { createContext, useContext } from "react";

import { type CartAction, type CartState } from "./hook.use-cart";

interface CartContextProps {
  cartState: CartState;
  dispatchCartAction: React.Dispatch<CartAction>;
}

const CartContext = createContext<CartContextProps | null>(null);

const useCartContext = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error("useCartContext must be used within a CartProvider ");
  }
  return context;
};

export { CartContext, useCartContext };
